import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Spinner } from "react-bootstrap";
import { Box, TextField, Checkbox, Button, FormControlLabel, Grid, Modal, Radio, RadioGroup } from "@mui/material";
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import toast, { Toaster } from 'react-hot-toast';
import FileViewer from './FileViewer';
import { useProjectName } from '../../Context/ProjectNameContext';

const LostItemPage = () => {
  const params = useParams();
  const [searchParams] = useSearchParams(); 
  const [userLocation, setUserLocation] = useState({ latitude: null, longitude: null });

  const [showRewardPopup, setShowRewardPopup] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [tandc, setTandc] = useState(true);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 
  const [qrcData, setQrcData] = useState("");
  const [scanId, setScanId] = useState("");
  const [termsandCondition, setTermsandcondition] = useState(false);
  const [finderID, setFinderID] = useState("");
  const [userDeviceId, setUserDeviceId] = useState("");
  const [claimReward, setClaimReward] = useState(null); 
  const [formData, setFormData] = useState({
    fullName: '',
    address: '',
    email: '',
    contactNumber: '',
    message: '',
    country: '',
    files: null,
  });

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;
  
          setUserLocation({ latitude: lat, longitude: lon });
          setError(null);
  
          // Reverse geocoding to get country code
          try {
            const response = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`);
            const data = await response.json();
            const countryCode = data.countryCode?.toLowerCase(); // e.g., "in", "us"
  
            if (countryCode) {
              setFormData(prev => ({
                ...prev,
                country: countryCode,
              }));
            }
          } catch (geoError) {
            console.error("Failed to fetch country from coordinates", geoError);
          }
        },
        (error) => {
          setError(error.message);
        }
      );
    } else {
      setError('Geolocation is not supported by this browser.');
    }
  };
  
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePhoneChangeEdit = (phone, field) => {
    setFormData({ ...formData, [field]: phone });
  };

   const handleSubmit = async (event) => {
    event.preventDefault();

    const data = new FormData();
    data.append('fullName', formData.fullName);
    data.append('address', formData.address);
    data.append('email', formData.email);
    data.append('contactNumber', formData.contactNumber);
    data.append('message', formData.message);
    data.append('files', formData.files); 
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/device/found/${userDeviceId}?scanId=${scanId}`, 
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      setFormData({
        fullName: '',
    address: '',
    email: '',
    contactNumber: '',
    message: '',
    country: '',
    files: null,
      });
      setShowRewardPopup(true);
      // console.log("Form submitted successfully:", response.data.data);
      setFinderID(response.data.data.finderId)
      toast.success("Form submitted successfully")
    } catch (error) {
      toast.error(error.response.data.message || "Failed SUbmiting form")
      console.error("Failed to submit form:", error);
    }
  };
   const handleReward = async () => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/device/finder/${finderID}`, 
        {
          acceptTermsAndCondition:true,
          claimReward:termsandCondition
        }, 
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      setShowTerms(false);
      setShowRewardPopup(false);
      setIsTermsAccepted(false)
     setFinderID("");
      // console.log("Form submitted successfully:", response.data);
      toast.success(response?.data?.message || "Form submitted successfully")
    } catch (error) {
      toast.error(error.response.data.message || "Failed SUbmiting form")
      console.error(error?.response?.data?.message || "Failed to submit form:", error);
    }
  };

  useEffect(() => {
    const scanIdFromUrl = searchParams.get("scanId");
    if (scanIdFromUrl) {
      setScanId(scanIdFromUrl);
    }
  }, [searchParams]);
  
  const handleGenerateQrc = async () => {
    const scanId = new URLSearchParams(window.location.search).get("scanId");

    const dataToSent = {
      scanId:scanId,
      lat: userLocation?.latitude,
      lon: userLocation?.longitude
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/qrc/scan/${params?.qrcid}`, dataToSent
      );
      // console.log("Details fetched successfully", response?.data?.data?.qrcContentData);
      setQrcData(response?.data?.data?.qrcContentData);
      setUserDeviceId(response?.data?.data?.qrcContentData?.userDeviceId)
    } catch (error) {
      console.error("Failed fetching details", error);
      setError("Failed to fetch details.");
    } finally {
      setLoading(false); 
    }
  };

  // useEffect(() => {
  //   const scanIdFromUrl = searchParams.get("scanId");
  //   setScanId(scanIdFromUrl); 
  //   console.log("Scan ID:", scanIdFromUrl); 
  //   handleGenerateQrc();
  // }, [searchParams]);

  const handleTerms = (value) => {
    setTermsandcondition(value)
    setShowTerms(true);
    setClaimReward(value);
  }
  const handleClaimReward = () => {
    setShowRewardPopup(false);
    setShowTerms(true);
  };

  const handleCheckboxChange = (event) => {
    setIsTermsAccepted(event.target.checked);
  };
   
   useEffect(() => {
    getLocation();
    if (userLocation?.latitude) {
      handleGenerateQrc();
    }
  }, [userLocation?.latitude]);

  
  return (
    <div>
<Toaster position="top-right" reverseOrder={false}/>
<Container>
        <Row>
          <Col lg={12} className="row m-0 p-0" style={{ background: "#fff" }}>
            <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', border: "1px solid #d3d3d3", borderRadius: "5px" }}>
              {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </div>
              ) : error ? (
                <div style={{ textAlign: 'center', color: 'red' }}>
                  {error}
                </div>
              ) : (
                <div>
                  {tandc && (
                    <div>
                      <h2 style={{ textAlign: 'center' }}>You scanned a lost item</h2>
                      <p style={{ fontSize: '20px', marginBottom: '20px', textAlign: 'center', color: "red", fontWeight: "600" }}>
                        A reward of {qrcData?.qrcContentId?.userDeviceId?.lostEventId?.currency} {qrcData?.qrcContentId?.userDeviceId?.rewardAmount} is set to return it back.
                      </p>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '5px', textAlign: "center" }}>
                        A service by Dirido.com
                      </div>
                      <div style={{ fontSize: '16px', marginBottom: '20px', textAlign: "center", textDecoration: "underline" }}>
                        Get your free service now!
                      </div>
                      {/* <p style={{ fontSize: '18px', marginBottom: '10px' }}>
                        Rajesh Sharma from Pune – India is the owner of this item.
                      </p> */}
                      {qrcData?.qrcContentId?.lostAndFoundContent?.isPublic && (
                        <div>
                      {(qrcData?.userData?.firstName || qrcData?.userData?.mobile || qrcData?.userData?.email) && (
                      <p style={{ fontSize: '18px', marginBottom: '5px' }}>
                        <strong>Owner details:</strong><br/>
                        {qrcData?.userData?.firstName && (<><strong>Name - </strong>{qrcData?.userData?.firstName} {qrcData?.userData?.lastName}
                        <br/></>)}
                        {qrcData?.userData?.email && (<><strong>Email - </strong>{qrcData?.userData?.email} </>)}
                        <br/>
                        {qrcData?.userData?.mobile && (<><strong>Mobile - </strong>{qrcData?.userData?.mobile} </>)}
                      </p>
                      )}
                      
                      {(qrcData?.qrcContentId?.userDeviceId?.itemName || qrcData?.qrcContentId?.userDeviceId?.itemDescription) && (
                      <p style={{ fontSize: '18px', marginBottom: '5px' }}>
                        <strong>Product details:</strong><br/>
                        {qrcData?.qrcContentId?.userDeviceId?.itemName && (<><strong>Name - </strong>{qrcData?.qrcContentId?.userDeviceId?.itemName} </>)}
                        <br/>
                        {qrcData?.qrcContentId?.userDeviceId?.itemDescription && (<><strong>Description - </strong>{qrcData?.qrcContentId?.userDeviceId?.itemDescription} </>)}
                      </p>
                      )}
                     {qrcData?.qrcContentId?.lostAndFoundContent?.lostLocationDescription && (
                      <p style={{ fontSize: '18px', marginBottom: '5px' }}>
                        <strong>Location - </strong>{qrcData?.qrcContentId?.lostAndFoundContent?.lostLocationDescription}
                      </p>
                      )}
                     {(qrcData?.qrcContentId?.lostAndFoundContent?.webPageLink && qrcData?.qrcContentId?.lostAndFoundContent?.includeConfig?.includeInfo?.includeWebPageLink) && (
                      <p style={{ fontSize: '18px', marginBottom: '5px' }}>
                        <strong>Web Page Link - </strong><a 
                        href={qrcData?.qrcContentId?.lostAndFoundContent?.webPageLink} 
                        target="_blank" 
                        rel="noopener noreferrer"
                      >
                        {qrcData?.qrcContentId?.lostAndFoundContent?.webPageLink}
                      </a>
                      </p>
                      )}
                      {qrcData?.qrcContentId?.lostAndFoundContent?.note && (<>
                      <p style={{ fontSize: '18px', fontStyle: 'italic', marginBottom: '0px' }}>
                        My note to you:
                      </p>
                      <p style={{ fontSize: '18px', marginBottom: '30px' }}>
                      {qrcData?.qrcContentId?.lostAndFoundContent?.note}
                      </p>
                      </>)}
                      {qrcData?.qrcContentId?.userDeviceId?.devicePhotos?.length > 0 && (
                      <div style={{marginBottom:"20px"}}>
                      <p style={{ fontSize: '18px', fontStyle: 'italic', marginBottom: '0px' }}>
                        Lost Item :
                      </p>
                      <FileViewer fileData={qrcData?.qrcContentId?.userDeviceId?.devicePhotos}/>
                      </div>)}

</div>)}
                      <p style={{ fontSize: '18px', marginBottom: '20px' }}>
                        You MAY fill the contact form below to contact owner directly.
                      </p>

                      <Box component="form" sx={{ "& .MuiTextField-root": { m: 1 } }} onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={6} style={{marginLeft:"-8px"}}>
          <TextField
            label="Name"
            name="fullName"
            required
            variant="outlined"
            fullWidth
            value={formData.fullName}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Email"
            name="email"
            type="email"
            required
            variant="outlined"
            fullWidth
            value={formData.email}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} >
           <PhoneInput
        country={formData.country || 'us'} 
        value={formData.contactNumber}
        onChange={phone => handlePhoneChangeEdit(phone, 'contactNumber')} 
        inputStyle={{ width: '100%' }}
        required
      />
        </Grid>
       
        <Grid item xs={12} style={{marginLeft:"-8px"}}>
          <TextField
            label="Address"
            name="address"
            variant="outlined"
            fullWidth
            multiline
            rows={2}
            value={formData.address}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} style={{marginLeft:"-8px"}}>
          <TextField
            label="Note"
            name="message"
            variant="outlined"
            multiline
            rows={4}
            fullWidth
            value={formData.message}
            onChange={handleInputChange}
          />
        </Grid>
        </Grid>

      <Box display="flex" justifyContent="center" mt={2}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
        >
          Submit
        </Button>
      </Box>
                      </Box>
                    </div>
                  )}
                  <Modal open={showRewardPopup} onClose={() => setShowRewardPopup(false)}>
                    <Box sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: "450px",
                      bgcolor: 'background.paper',
                      boxShadow: 24,
                      p: 4,
                      borderRadius: '10px',
                      textAlign: 'center',
                    }}>
                      <h4>Do you wish to claim your reward?</h4>
                      <p style={{ marginBottom: "20px", fontSize: "14px", color: "#555" }}>
      You will get your reward either through escrow or directly paid by the owner.
    </p>
                      <Button variant="contained" onClick={()=>handleTerms(true)} style={{ marginTop: "20px", width: "100px", padding: "5px 10px" }}>
                        Yes
                      </Button>
                      <Button variant="contained" onClick={() => handleTerms(false)} style={{ marginTop: "20px", width: "100px", padding: "5px 10px", marginLeft: "20px" }}>
                        No
                      </Button>
                    </Box>
                  </Modal>

                  <Modal open={showTerms} onClose={() => setShowTerms(false)}>
                    <Box sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: '480px',
                      maxWidth:"90%",
                      maxHeight: '85%',
                      bgcolor: 'background.paper',
                      boxShadow: 24,
                      p: 4,
                      borderRadius: '10px',
                      overflowY: 'auto',
                    }}>
                      <h3>Terms to Accept</h3>
                      <p>To claim the reward, you should:</p>
                      <ul style={{ textAlign: 'left', marginBottom: '20px' }}>
                        {claimReward ? (
                          <>
                            <li>Communicate with the item owner.</li>
                            <li>Share a photo or video showing you and the found item & Dirido QRC.</li>
                            <li>Irrevocably accept the terms and liabilities discharging Dirido from any liability.</li>
                            <li>Ensure the owner releases the escrow after item delivery.</li>
                          </>
                        ) : (
                          <>
                            <li>You are not obligated to claim the reward.</li>
                            <li>No communication with the item owner is required.</li>
                            <li>Ensure the item is kept in safe custody until further instructions.</li>
                            <li>Dirido team will assist you in handling the found item.</li>
                          </>
                        )}
                      </ul>
                      <FormControlLabel
                        control={<Checkbox checked={isTermsAccepted} onChange={handleCheckboxChange} />}
                        label="I accept the terms and conditions"
                      />
                      <Box display="flex" justifyContent="center" mt={2}>
                        <Button
                          variant="contained"
                          onClick={handleReward}
                          disabled={!isTermsAccepted}
                        >
                          Accept
                        </Button>
                      </Box>
                    </Box>
                  </Modal>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LostItemPage;
